<div>
  <app-select
    [questions]="questions"
    [selectedOptionId]="selectedOptionId"
    [isFilterOpen]="isFilterOpen"
    (questionSelected)="handleQuestionSelected($event)"
  ></app-select>
</div>

@if (statusDetail === 'error') {
  <div class="chart-card-bar text-center mt-4">
    <img
      src="../../../../assets/images/training-quizzes/nodata-img.svg"
      class="responsive-image mx-auto"
      alt=""
    />
    <h5 class="mt-2">{{ errorMessage }}</h5>
  </div>
}
@if (statusDetail === 'loading') {
  <mat-spinner class="mx-auto"></mat-spinner>
}
@if (statusDetail === 'init' || statusDetail === 'success') {
  <div class="metrics-by-question" [class.filter-active]="isFilterOpen">
    @if (questionOption) {
      <div class="chart-card-bar">
        <div class="chart-bar-container">
          @if (showChart) {
            <ngx-charts-bar-horizontal
              class="chart d-none d-md-block"
              [scheme]="colorScheme"
              [results]="questionOption"
              [xAxis]="false"
              [yAxis]="true"
              [legend]="false"
              [barPadding]="75"
              [noBarWhenZero]="false"
              [xScaleMax]="barNumber"
              [maxYAxisTickLength]="40"
              [xAxisTickFormatting]="xAxisFormat"
              [wrapTicks]="true"
              [showGridLines]="false"
            >
            </ngx-charts-bar-horizontal>
          }
          @if (showChart) {
            <ngx-charts-bar-horizontal
              class="chart d-block d-md-none"
              [scheme]="colorScheme"
              [results]="questionOption"
              [xAxis]="false"
              [yAxis]="false"
              [legend]="false"
              [noBarWhenZero]="false"
              [xScaleMax]="barNumber"
              [xAxisTickFormatting]="xAxisFormat"
              [showGridLines]="false"
            >
            </ngx-charts-bar-horizontal>
          }
        </div>
        <div>
          <p class="chart-text-time text-center">
            {{ 'pages.QUIZ-CHARTS.RESPONSE-DISTRIBUTION' | transloco }}
          </p>
        </div>
      </div>
    }
    @if (questionOption) {
      <div class="metrics-circule">
        <app-time-display
          *transloco="let text; prefix: 'pages.QUIZ-CHARTS'"
          [chartTitle]="text('AVERAGE-TIME')"
          [timeInSeconds]="timeInMinutesAndSeconds"
          class="chart-card"
        ></app-time-display>
        @if (questionOption) {
          <app-general-chart
            [resultPercentage]="result"
            [chartTitle]="chartTitle"
            class="chart-card"
            [isFilterOpen]="isFilterOpen"
          ></app-general-chart>
        }
      </div>
    }
  </div>
}
